import Vue from 'vue';
import Vuex from 'vuex';
import http from 'lib/http';
Vue.use(Vuex);
export const MU_UPATE_AUTH = 'MU_UPATE_AUTH';
export const MU_UPATE_SCHOOL = 'MU_UPATE_SCHOOL';
export default new Vuex.Store({
  state: {
    auth: {
      code: -101, // 没有发送用户信息请求
      loading: false,
    },
    association: {},
  },
  mutations: {
    [MU_UPATE_AUTH](state, value) {
      if (value && value.isLogin) {
        state.auth = value;
      } else {
        // 传空值时将登录状态初始化
        state.auth = {
          code: -101,
          loading: false,
        };
      }
    },
    [MU_UPATE_SCHOOL](state, value) {
      state.association = value;
    },
  },
  actions: {
    [MU_UPATE_AUTH](context) {
      const req = http.post('/api/XOrg/XLogin/getAuthInfo').then(
        function(res) {
          let roles = res.code > 0 ? {} : {};

          let auth = {
            loading: false,
            isLogin: res.code > 0, // 已经登录
            ...res,
            ...roles,
          };
          context.commit(MU_UPATE_AUTH, auth);
          return auth;
        },
        function() {
          console.log('请求失败处理');
        }
      );
      // 保存登录状态
      // if(context.state.auth) {
      context.commit(MU_UPATE_AUTH, {code: -101, loading: true, request: req});
      // }
      return req;
    },
    [MU_UPATE_SCHOOL](context, code) {
      const req = http
        .post('/api/XOrg/AssociationIndex/getAssociationId', {
          realmName: code,
        })
        .then(function(rst) {
          // if (rst && rst.code === 1) {
          //   context.commit(MU_UPATE_SCHOOL, rst);
          // }
          let info = {
            Id: 'zqpzabyqcabcrdjhqzznea',
            Logo:
              'https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/SrQQD8baRGrKY3PS.png',
            // Logo:"",
            associationName: '北京中物联物流采购培训中心',
          };
          if (rst.association) {
            info = rst.association;
          }
          // let info = rst.info;
          context.commit(MU_UPATE_SCHOOL, info);
        });
      context.state.request = req;
      return req;
    },
  },
});
